module.exports = __webpack_public_path__ + "img/gb9877_1-88-55x72x8.prt.ccfcbdd0.jpg";